import React, { ReactElement } from "react";
import { gql, useMutation, useQuery } from "urql";
import { Button } from "../../../../components/src/Button";
import { REDIS_KEYS, DELETE_REDIS_KEY } from "../../../../graphql/src/redis/queries";
import { userHaveAccessTo } from "../../common/Permissions";
import { PermissionAssetEnum } from "../../types.generated";

const GET_ME = gql`
    query {
        me {
            personalNumber
            roles {
                _id
                assets
                clientIds
                permissionType
                name
            }
        }
    }
`;

export function AdminRedisPage(): ReactElement {
    const [{ fetching: loadingMe, error: errorMe, data: getMe }] = useQuery({ query: GET_ME });
    const [{ fetching, error, data }, refetch] = useQuery<{ redisKeys?: string[] }>({
        query: REDIS_KEYS,
        requestPolicy: "network-only"
    });
    const [_, deleteRedisKey] = useMutation(DELETE_REDIS_KEY);

    if (errorMe) return <pre>{JSON.stringify(errorMe, null, 2)}</pre>;
    if (error) return <pre>{JSON.stringify(error, null, 2)}</pre>;

    if (loadingMe || fetching)
        return (
            <div>
                <div>Loading</div>
            </div>
        );

    if (!userHaveAccessTo("Any", PermissionAssetEnum.Admin, getMe.me.roles)) {
        return <div>You don't have access to this page</div>;
    }

    return (
        <div className="admin-page">
            <h2>Redis Keys</h2>
            <table className="table table-striped table-bordered table-hover table-responsive">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Redis Key</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {data.redisKeys.map((key, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                                <code className="text-break">{key}</code>
                            </td>
                            <td>
                                <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={async () => {
                                        console.log("Deleting key: ", key);
                                        await deleteRedisKey({ key: key })
                                            .catch((error) => {
                                                console.error(error);
                                            })
                                            .finally(() => {
                                                console.log("refetch()");
                                                refetch({ requestPolicy: "network-only" });
                                            });
                                    }}
                                >
                                    Delete
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
